import { RoleGraphConfigDto, RoleTileConfigDto } from "./tenants/practice-analytics.models";

export class UserRole {
  id: number;
  name: string;
}

export class RoleMaster {
  id: number;
  name: string;
  description: string;
  isActive: string;
  customerId: string;
  isSystemRole: boolean;
  isSystemRoleStr?: string;
}

export class RoleMasterListRes {
  roleList: RoleMaster[];
  totalRecords: number;
}

export class UserRoleDetails {
  id?: number;
  name: string;
  description: string;
  isActive: boolean;
  practiceId?: number;
  isSystemRole: boolean;
  roleDetails: RoleDetails[];
  graphList: RoleGraphConfigDto[];
  tileList:  RoleTileConfigDto[];
}

export class RoleMasterData {
  roleMaster: RoleMaster;
  roleDetails: RoleDetails[];
  graphList: RoleGraphConfigDto[];
  tileList: RoleTileConfigDto[];
}

class RoleDetails {
  roleId?: number;
  moduleId: number;
  menuId: number;
  parentId?: number;
}

export class AllRoleListReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
}

export class RoleMasterRequest {
  id?: number;
  name: string;
  description: string;
  isActive: boolean;
  practiceId?: number;
  isSystemRole: boolean;
  roleDetails: RoleDetails[];
  graphList: number[];
  tileList:  number[];
}
